import { render, staticRenderFns } from "./SectionHeadlineTitleText.vue?vue&type=template&id=3a534c10&scoped=true&"
import script from "./SectionHeadlineTitleText.vue?vue&type=script&lang=js&"
export * from "./SectionHeadlineTitleText.vue?vue&type=script&lang=js&"
import style0 from "./SectionHeadlineTitleText.vue?vue&type=style&index=0&id=3a534c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a534c10",
  null
  
)

export default component.exports